import { round } from "lodash-es";

export const roundAndLocalizeNumber = (num: number, decimals: number = 2) => {
  return round(num, decimals).toLocaleString();
};
